// extracted by mini-css-extract-plugin
export default {"fullHeight":"X0vCEZ"};